<template>
  <div class="book-container">
    <div class="head-dec"></div>
    <div class="main-block" :style="{height: height / scale - 84 - 62 + 'px'}">
      <div class="left-panel">
        <div class="box des">
          <div class="cover">
            <img id="bookImg" class="cover-image" />
            <div class="cover-right">
              <div class="part-title">&diams;<span class="inline-title">本书著录信息</span></div>
              <div class="row un-tran"><b>标题</b>&nbsp;&nbsp;{{ book.title }}</div>
              <div class="row un-tran"><b>四部分类</b>&nbsp;&nbsp;{{ book.fdc }}</div>
              <div class="row un-tran"><b>关键词</b>&nbsp;&nbsp;{{ book.keyword }}</div>
              <div class="row un-tran"><b>数量</b>&nbsp;&nbsp;{{ book.quantity }}</div>
              <div class="row un-tran" :title="book.edition"><b>版本</b>&nbsp;&nbsp;{{ book.edition }}</div>
              <div class="row un-tran"><b>馆藏信息</b>&nbsp;&nbsp;{{ book.location }}</div>
              <div class="row un-tran"><b>收藏单位</b>&nbsp;&nbsp;{{ book.collectionUnit }}</div>
            </div>
          </div>
          <div class="row" style="margin-top: 12px; white-space: wrap">
            <b>文献摘要</b>
            <div class="un-tran" style="text-indent: 2em; height: 134px;overflow-y: auto;">
              {{ book.summary }}
            </div>
          </div>
        </div>
        <catalog />
      </div>
      <Reader :book="book" :bookId="bookId" @copyAction='saveCopyUserAction' />
    </div>
  </div>
</template>

<script>
import Reader from './reader'
import Catalog from './catalog'
import { getSearchParams, getBase64FromSinglePDF } from '@/utils'
import api from '@/api'
import { mapGetters } from 'vuex'
import userActionsApi from '@/api/userActions.js'
export default {
  data () {
    return {
      bookId: '',
      initBook: {},
      originInfos: {},
      height: window.innerHeight,
      scale: window.innerWidth / 1920
    }
  },
  components: {
    Reader,
    Catalog
  },
  computed: {
    ...mapGetters(['isTra', 'library']),
    book () {
      return this.isTra ? this.originInfos : this.initBook
    }
  },
  methods: {
    async getBook () {
      let res = await api.bookSearch({
        pageIndex: 1,
        pageSize: 1,
        bookId: this.bookId
      })
      this.initBook = res.rows[0]
      this.originInfos = JSON.parse(res.rows[0].originInfos)
      await this.initImg()
    },
    saveCopyUserAction () {
      // 复制行为
      userActionsApi.addUserAction({
        actionCode: 'dataCopy',
        bookId: this.bookId,
        resourceId: this.book.id,
        resourceInfos: JSON.stringify(this.initBook),
        resourceCategory: 'bookMetaData',
        terminalType: this.$isPhone ? 'mobile' : 'pc'
      })
    },
    async initImg () {
      let bookFilePath = process.env.NODE_ENV === 'production' ? this.library.bookFilePath : 'http://localhost:8047/book'
      let src = await getBase64FromSinglePDF(`${bookFilePath}/pdf/${this.bookId}/0001/0001.pdf`)
      document.getElementById('bookImg').setAttribute('src', src)
    }
  },
  mounted () {
    document.querySelector('.footer-container').style.display = 'none'
    let queryObj = getSearchParams(window.location.href)
    this.bookId = queryObj.bookId
    this.getBook()
  },
  beforeDestroy () {
    document.querySelector('.footer-container').style.display = 'flex'
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.book-container {
  width: 1920px;
  background-color: #F5F2EB;
  background-image: url("~@/assets/images/bottom-bg.png");
  background-size: 1920px 278px;
  background-position: bottom;
  background-repeat: no-repeat;
  .main-block {
    width: 1846px;
    height: 806px;
    margin-left: 32px;
    display: flex;
    font-family: "FangZhengKaiTi-GBK";
    padding: 12px 0;
    .left-panel {
      width: 390px;
      height: 100%;
      overflow-y: auto;
      overflow-x: visible;
      .des {
        width: 100%;
        height: 390px;
        .cover {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .cover-image {
            width: 145px;
            height: 198px;
            background-color: #7a7374;
          }
          .cover-right {
            width: 199px;
            height: 198px;
            margin-left: 12px;
          }
        }
      }
      .row {
        color: #7a7374;
        .font-size-default;
        line-height: 23px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
    .right-panel {
      width: 1444px;
      height: 100%;
      margin-left: 24px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
